import { FormattedOption } from 'types/dictionaries';

export const getCountryCodeFromApplication = (
  locationCountry: string,
  countriesDictionary: FormattedOption[]
) => {
  if (locationCountry === 'USA') {
    return 'US';
  }

  const countryObject = countriesDictionary.find(
    (option) =>
      option.value === locationCountry || option.label === locationCountry
  );

  return countryObject?.value ? countryObject?.value : '';
};
